import { useState, useCallback } from 'react';
import axiosInstance from '../api/Axios';

export const useApi = (endpoint) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchData = useCallback(async (params = {}) => {
    setLoading(true);
    try {
      const result = await axiosInstance.get(endpoint, { params });
      setData(result.data);
      setError(null);
      return result.data;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [endpoint]);

  const postData = useCallback(async (body, params = {}) => {
    setLoading(true);
    try {
      const result = await axiosInstance.post(endpoint, body, { params });
      setData(result.data);
      setError(null);
      return result.data;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [endpoint]);

  const putData = useCallback(async (body, params = {}) => {
    setLoading(true);
    try {
      const result = await axiosInstance.put(endpoint, body, { params });
      setData(result.data);
      setError(null);
      return result.data;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [endpoint]);

  const deleteData = useCallback(async (id) => {
    setLoading(true);
    try {
      const url = `${endpoint}/${id}`;
      const result = await axiosInstance.delete(url);
      setData(result.data);
      setError(null);
      return result.data;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [endpoint]);

  return { data, error, loading, fetchData, postData, putData, deleteData };
}; 